import React, {Component} from "react"
import {Button, Container, Header, Loader, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, formatMoneyAmount, getStepProps, isAIG, isAnsel, isRenaissance, PLAN_PAYS_ROUTE} from "../utils/common";
import Steps from "./steps/steps";
import Footer from "./footer";
import {CustomDivider, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        ...ownProps,
        lang: user.lang,
        initialData, user, benAdmin,
        isBrellaChoice: !!initialData && !!initialData.contractInfo && initialData.contractInfo.planOffering === "Brella Choice"
    }
};

class HowYourPlanPays extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    render() {
        const {stepProps} = this.state;
        const {initialData, isBrellaChoice, lang} = this.props;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(lang);
        const strings = localization.howYourPlanPays;

        let paymentColumnTitle = '';
        const values = {}
        if (isBrellaChoice) {
            if (!!initialData && !!initialData.increments) {
                const inc = initialData.increments;
                paymentColumnTitle = `${strings.choiceIncrements}`;
                try {
                    const separator = " -"
                    values.moderate = `$${formatMoneyAmount(inc.moderate[0])} ${separator} $${formatMoneyAmount(inc.moderate[inc.moderate.length - 1])}`
                    values.severe = `$${formatMoneyAmount(inc.severe[0])} ${separator} $${formatMoneyAmount(inc.severe[inc.severe.length - 1])}`
                    values.catastrophic = `$${formatMoneyAmount(inc.catastrophic[0])} ${separator} $${formatMoneyAmount(inc.catastrophic[inc.catastrophic.length - 1])}`
                } catch (e) {
                    console.error(e);
                    values.moderate = '';
                    values.severe = '';
                    values.catastrophic = '';
                }
            }
        } else {
            if (!!initialData && !!initialData.presets) {
                const pre = initialData.presets;

                paymentColumnTitle = `${strings.selectPayout}`

                let show = []
                const presets = ['value', 'enhanced', 'premier']
                const levels = ['moderate', 'severe', 'catastrophic']

                show = presets.filter(preset => pre[preset].show !== false)

                levels.forEach(level => {
                    values[level] = show.map(preset => `$${formatMoneyAmount(pre[preset][level])}`).join(', ')
                })
            }
        }

        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8} className={"neutral700Text"}>
                            <Header as='h2'>{strings.title}</Header>
                            <p>{strings.description}</p>
                            <CustomDivider hidden/>
                            <p><i>{strings.payoutsTitle}</i></p>
                            <CustomDivider hidden/>

                            <Segment basic  padded>
                            <CustomGrid columns={3} relaxed verticalAlign={"middle"}>
                                <CustomGrid.Column style={{height: '100px'}} width={3} className={"dashedTopBorder"}>
                                    <span className={"secondaryHeaderColor"}><b>{strings.moderate}</b></span>
                                </CustomGrid.Column>
                                <CustomGrid.Column className={"dashedTopBorder"} style={{height: '100px'}}>
                                    <span className={"small neutral700Text"}><b>6,000+ {strings.conditions}</b></span>
                                </CustomGrid.Column>
                                <CustomGrid.Column width={5} className={"dashedTopBorder"} textAlign={"center"} style={{height: '100px'}}>
                                    <div className={"small"}><b>{paymentColumnTitle}</b></div>
                                    <div className={"howYourPlanPaysValueBackground"} style={{borderRadius: '50px', padding: '.5em', margin: '3px 7px 0 7px'}}><span
                                        className={"primaryBoldColor small"}>{values.moderate}</span></div>
                                </CustomGrid.Column>

                                <CustomGrid.Column style={{height: '100px'}} width={3} className={"dashedTopBorder"}>
                                    <span className={"secondaryHeaderColor"}><b>{strings.severe}</b></span>
                                </CustomGrid.Column>
                                <CustomGrid.Column style={{height: '100px'}} className={"dashedTopBorder"}>
                                    <span className={"small neutral700Text"}><b>5,600+ {strings.conditions}</b></span>
                                </CustomGrid.Column>
                                <CustomGrid.Column width={5} className={"dashedTopBorder"} textAlign={"center"} style={{height: '100px'}}>
                                    <div className={"small"}><b>{paymentColumnTitle}</b></div>
                                    <div className={"howYourPlanPaysValueBackground"} style={{borderRadius: '50px', padding: '.5em', margin: '3px 7px 0 7px'}}><span
                                        className={"primaryBoldColor small"}>{values.severe}</span></div>
                                </CustomGrid.Column>

                                <CustomGrid.Column style={{height: '100px'}} width={3} className={"dashedTopBorder dashedBottomBorder"}>
                                    <span className={"secondaryHeaderColor"}><b>{strings.catastrophic}</b></span>
                                </CustomGrid.Column>
                                <CustomGrid.Column style={{height: '100px'}} className={"dashedTopBorder dashedBottomBorder"}>
                                    <span className={"small neutral700Text"}><b>1,500+ {strings.conditions}</b></span>
                                </CustomGrid.Column>
                                <CustomGrid.Column width={5} className={"dashedTopBorder dashedBottomBorder"} textAlign={"center"} style={{height: '100px'}}>
                                    <div className={"small"}><b>{paymentColumnTitle}</b></div>
                                    <div className={"howYourPlanPaysValueBackground"} style={{borderRadius: '50px', padding: '.5em', margin: '3px 7px 0 7px'}}><span
                                        className={"primaryBoldColor small"}>{values.catastrophic}</span></div>
                                </CustomGrid.Column>
                            </CustomGrid>
                            </Segment>


                            <CustomDivider hidden/>
                            <CustomGrid columns={2}>
                                <CustomGrid.Column className={'howItPaysBottomLine howItPaysLeftLine'}/>
                                <CustomGrid.Column className={'howItPaysBottomLine howItPaysRightLine'}/>
                                <CustomGrid.Column className={'howItPaysRightLine'}/>
                                <CustomGrid.Row centered>
                                <CustomGrid.Column width={9} textAlign={"center"}>
                                    <p>{strings.payoutComment}</p>
                                    <CustomDivider hidden/>
                                </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>


                            <Segment basic className={'lightBackground'} padded>
                                <Header as={"h4"}>{strings.seeHow}</Header>
                                <CustomGrid verticalAlign={"middle"}>
                                    <CustomGrid.Column width={2}>
                                        <S3Image {...IMAGE.AMBER}/>
                                    </CustomGrid.Column>
                                <CustomGrid.Column width={10} style={{paddingLeft: '.5em'}}>
                                    <div className="small neutral700Text" style={{marginBottom: '1em'}}>
                                    {isAnsel() || isAIG() || isRenaissance() ?
                                        <>
                                            <div>{strings.howBenefited}</div>
                                            <p>{strings.scenarios}</p>
                                        </> :
                                        <div>{strings.howBenefitedScenarios}</div>
                                    }
                                    </div>
                                    <Button basic primary compact onClick={() => this.props.history.push(`${PLAN_PAYS_ROUTE}/1`)}>
                                        {strings.readStories}
                                    </Button>
                                </CustomGrid.Column>
                                </CustomGrid>
                            </Segment>

                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(HowYourPlanPays));
